import { useDropdownClickOutside } from '@/components/common/Dropdown/useDropdownClickOutside'
import { type ComponentProps, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown, IconButton, VerticalMenu } from '@/components/common'
import { Link } from '@tanstack/react-router'
import type { RenderMenuItemFnProps } from '@/components/common/MenuItem/MenuItem'
import type { TFunction } from 'i18next'

const renderFn = (props: RenderMenuItemFnProps): React.ReactNode => {
    const { item, renderContents } = props
    return (
        <Link to={item.path}>
            {({ isActive }: { isActive: boolean }) => renderContents(isActive)}
        </Link>
    )
}

const getMenuItems = (t: TFunction) => {
    return [
        {
            id: 'usage-and-cost',
            path: '/analytics/usage-and-cost',
            label: t('dashboard.usage_cost_card.dropdown.view_report'),
        },
    ]
}

type UsageAndCostDropdownActionsProps = {
    buttonProps: ComponentProps<typeof IconButton>
}

const UsageAndCostDropdownActions: React.FC<
    UsageAndCostDropdownActionsProps
> = ({ buttonProps }) => {
    const { t } = useTranslation('translations')
    const [isOpen, setIsOpen] = useState(false)

    const { buttonRef, dropdownRef } = useDropdownClickOutside(() => {
        if (isOpen) {
            setIsOpen(false)
        }
    })

    const menuItems = getMenuItems(t)

    return (
        <div className="z-50">
            <Dropdown
                name="widget-actions-dropdown"
                buttonComponent={IconButton}
                buttonProps={{
                    ...buttonProps,
                    buttonRef: buttonRef,
                }}
                horizontalAlign="right"
                dropdownClassname="py-3"
                isOpen={isOpen}
                dropdownRef={dropdownRef}
                onClick={() => {
                    setIsOpen((isOpen) => !isOpen)
                }}
            >
                <VerticalMenu
                    menuItems={menuItems}
                    variant={'primary'}
                    hideLabel={false}
                    render={renderFn}
                    menuItemClassName={'w-auto whitespace-normal break-words'}
                />
            </Dropdown>
        </div>
    )
}

export default UsageAndCostDropdownActions
